import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin } from "antd";
import { __custom_card } from "../__custom_card";
import {
  SelectBox,
  InputBox,
  isBrowser,
  DatePicker,
} from "../../../../shared/custom-ant-d";
import passwordValidator from "password-validator";
import { formField } from "./_formField";
import { DatePicker as DatePickerBV } from "antd";
import moment from "moment";
import { ZipRegex, PhoneRegex } from "../../../../shared/helpers";

const schema = new passwordValidator();

export const FormCOL = (props) => {
  const {
    form,
    disableAll,
    allCountryList,
    emergencyContactRelationshipList,
    languageList,
    maritalStatusList,
    nameSuffixList,
    salutationList,
    statesList,
    usGenderList,
  } = props;

  const [disableMailFields, setDisableMailFields] = useState(false);

  return (
    <>
      <Card type="inner">
        <__custom_card title={"Enter name as shown on National ID Card"}>
          <Row justify={"start"}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="First Name"
                name={formField.legalFirstName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Middle Name" name={formField.middleName}>
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Last Name"
                name={formField.legalLastName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Salutation" name={formField.salutation}>
                <SelectBox
                  data={
                    salutationList &&
                    salutationList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  label={""}
                  disabled={disableAll}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !salutationList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Suffix" name={formField.suffix}>
                <SelectBox
                  data={
                    nameSuffixList &&
                    nameSuffixList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !nameSuffixList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Enter Gender and Marital Status"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Gender"
                name={formField.gender}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    usGenderList &&
                    usGenderList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!usGenderList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }}>
              <Form.Item
                label="Marital Status"
                name={formField.maritalStatus}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    maritalStatusList &&
                    maritalStatusList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !maritalStatusList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Enter Language Skills"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Language"
                name={formField.primaryLanguage}
              >
                <SelectBox
                  data={
                    languageList &&
                    languageList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!languageList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Seconday Language"
                name={formField.secondaryLanguage}
              >
                <SelectBox
                  data={
                    languageList &&
                    languageList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!languageList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Biographical and National ID Information"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Date of Birth"
                name={formField.dob}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      var now = moment(new Date()); //todays date
                      var end = moment(value); // another date
                      var duration = moment.duration(now.diff(end));
                      var years = duration.asYears();
                      if (years >= 18) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          "You must be 18 years or older to be hired."
                        );
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <DatePickerBV
                    disabled={disableAll}
                    format={"MM/DD/YYYY"}
                    label={""}
                    onChange={(value) => {
                      // form.setFieldsValue({ dob: value })
                    }}
                  />
                ) : (
                  <DatePicker
                    disabled={disableAll}
                    label={""}
                    onChange={(value) => {
                      // form.setFieldsValue({ dob: value })
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Country of Birth"
                name={formField.countryOfBirth}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList &&
                    allCountryList.map((item, i) => {
                      return {
                        value: item.countryName,
                        label: item.countryName,
                      };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !allCountryList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Nationality"
                name={formField.nationality}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList &&
                    allCountryList.map((item, i) => {
                      return {
                        value: item.countryName,
                        label: item.countryName,
                      };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !allCountryList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="National ID Country"
                name={formField.jobReqCountryCode}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={true} />
                ) : (
                  <InputBox disabled={true} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Cedula"
                name={formField.cedula_De_Ciudadania_CO}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      if (value === "") {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject("Cedula must be a number.");
                      } else if (value.length < 5 || value.length > 15) {
                        return Promise.reject(
                          "Cedula must be atleast 5-15 digits."
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Primary Home Address"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="CountryCode"
                name={formField.countryCode}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Country"
                name={formField.countryName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList &&
                    allCountryList.map((item, i) => {
                      return {
                        value: item.countryName,
                        label: item.countryName,
                      };
                    })
                  }
                  disabled={true}
                  label={""}
                  onChange={(value) => {
                    var label = allCountryList.filter(
                      (i) => i.countryName == value
                    );
                    form.setFieldsValue({ CountryCode: label[0]?.CountryCode });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ CountryName: value });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !allCountryList ? <Spin size="small" /> : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Street/Avenue Number"
                name={formField.streetAvenueNumber}
                rules={[{ required: true }]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="StateID" name={formField.stateID} hidden={true}>
                <Input />
              </Form.Item>
              <Form.Item
                label="Department"
                name={formField.stateName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    statesList &&
                    statesList.map((item, i) => {
                      return { value: item.stateName, label: item.stateName };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  onChange={(value) => {
                    var label = statesList.filter((i) => i.stateName == value);
                    form.setFieldsValue({ StateID: label[0]?.stateID });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ StateName: value });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!statesList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="City"
                name={formField.city}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Postal Code"
                name={formField.zipCode}
                rules={[
                  { required: false },
                  () => ({
                    validator(_, value) {
                      if (value === "" || value === undefined) {
                        return Promise.resolve();
                      }

                      let isCheck = ZipRegex("COL");
                      if (!isCheck.regex.test(value)) {
                        return Promise.reject(isCheck.msg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Enter Contact Information"}>
          <Row justify="start" gutter={8}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Mobile/Primary Phone"
                name={formField.mobilePrimaryPhone}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      let isCheck = PhoneRegex("IND");
                      if (!isCheck.regex.test(value)) {
                        return Promise.reject(isCheck.msg);
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Secondary Phone"
                name={formField.secondaryPhone}
                rules={[
                  () => ({
                    validator(_, value) {
                      schema.is().not().letters().is().not().symbols();

                      if (value == null || value === "") {
                        return Promise.resolve();
                      }

                      if (value != null && value.length != 10) {
                        return Promise.reject(
                          "Secondary Phone must be 10 digit number."
                        );
                      } else if (
                        !schema
                          .validate(value, { list: true })
                          .includes("letters") &&
                        !schema
                          .validate(value, { list: true })
                          .includes("symbols")
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          "Secondary Phone must contain numbers only."
                        );
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={"Tell us who to contact in Case of Emergency"}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="emergencyContactRelationID1"
                name={formField.emergencyContactRelationID1}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Relationship"
                name={formField.emergencyContactRelationName1}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <SelectBox
                  data={
                    emergencyContactRelationshipList &&
                    emergencyContactRelationshipList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  onChange={(value) => {
                    var label = emergencyContactRelationshipList.filter(
                      (i) => i.expText == value
                    );
                    form.setFieldsValue({
                      EmergencyContactRelationID1: label[0]?.codeValueID,
                    });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ EmergencyContactRelationID1: null });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !emergencyContactRelationshipList ? (
                      <Spin size="small" />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Name"
                name={formField.emergencyContactName1}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Phone Number"
                name={formField.emergencyContactPhone1}
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      if (value === "") {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject(
                          "Primary Phone must be a number."
                        );
                      } else if (value.length < 7 || value.length > 10) {
                        return Promise.reject(
                          "Primary Phone must be atleast 7-10 digits."
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Email Address"
                name={formField.emergencyContactEmail1}
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid email",
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="emergencyContactRelationID2"
                name={formField.emergencyContactRelationID2}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Relationship"
                name={formField.emergencyContactRelationName2}
              >
                <SelectBox
                  data={
                    emergencyContactRelationshipList &&
                    emergencyContactRelationshipList.map((item, i) => {
                      return { value: item.expText, label: item.expText };
                    })
                  }
                  disabled={disableAll}
                  label={""}
                  onChange={(value) => {
                    var label = emergencyContactRelationshipList.filter(
                      (i) => i.expText == value
                    );
                    form.setFieldsValue({
                      emergencyContactRelationID2: label[0]?.codeValueID,
                    });
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ emergencyContactRelationID2: null });
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={
                    !emergencyContactRelationshipList ? (
                      <Spin size="small" />
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item label="Name" name={formField.emergencyContactName2}>
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Phone Number"
                name={formField.emergencyContactPhone2}
                rules={[
                  () => ({
                    validator(_, value) {
                      if (value === "" || value === undefined) {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject(
                          "Primary Phone must be a number."
                        );
                      } else if (value.length < 7 || value.length > 10) {
                        return Promise.reject(
                          "Primary Phone must be atleast 7-10 digits."
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                labelCol={{ md: { offset: 1 } }}
                wrapperCol={{ md: { span: 24 } }}
                label="Email Address"
                name={formField.emergencyContactEmail2}
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid email",
                  },
                ]}
              >
                {isBrowser ? (
                  <Input disabled={disableAll} />
                ) : (
                  <InputBox disabled={disableAll} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
      </Card>
    </>
  );
};
